import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-upload_cloud",
  "use": "icon-upload_cloud-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-upload_cloud\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M12,12.59l4.24,4.24-1.41,1.41L13,16.42V22H11V16.41L9.17,18.24,7.76,16.83ZM12,2a7,7,0,0,1,7,6.19A5.5,5.5,0,0,1,18,19V17A3.5,3.5,0,1,0,17,10l-.12,0a5,5,0,1,0-9.78,0,3.5,3.5,0,0,0-1.29,6.88L6,17v2a5.5,5.5,0,0,1-1-10.79A7,7,0,0,1,12,2Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol